import { BASE } from './index';
import axios from './http';
const ren = {
    // 装修详情
    configinfo: params => axios.post(`${BASE.PRO1}/home/config/info`,  params ),
    // 首页配置 - 初始化分类数据
    firstcategory: params => axios.post(`${BASE.PRO1}/home/config/first/category`,  params ),
    //首页配置 - 保存
    configsetting: params => axios.post(`${BASE.PRO1}/home/config/setting`,  params ),
    //首页配置 - 轮播图
    bannerlist: params => axios.post(`${BASE.PRO1}/home/config/banner/list`,  params ),
    //首页配置 - 轮播图
    activitylist: params => axios.post(`${BASE.PRO1}/home/config/activity/list`,  params ),

};

export default ren;
